import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import { Client } from '@microsoft/microsoft-graph-client';
export default {

    async signInWithAD() {
        try {
            const config = {
                auth: {
                    clientId: process.env.VUE_APP_AZURE_APPLICATION_ID,
                    authority: process.env.VUE_APP_AZURE_AUTHORITY,
                    redirectUri: process.env.VUE_APP_AZURE_REDIRECT_URI,
                },
                cache: {
                    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
                },
            };
            let publicClientApplication = new PublicClientApplication(config);

            const AuthProviderOptions = {
                account: {},
                scopes: ['openid', 'profile', 'User.Read'],
                interactionType: InteractionType.Popup,
            };

            // Pass the PublicClientApplication instance from step 2 to create AuthCodeMSALBrowserAuthenticationProvider instance
            const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
                publicClientApplication,
                AuthProviderOptions
            );

            // Initialize the Graph client
            const graphClient = await Client.initWithMiddleware({ authProvider });

            let graphUser = await graphClient.api('/me')
                .select('id,displayName,userPrincipalName,mail,companyName,street,streetaddress,city, state,postalcode,officeLocation,mobilePhone,businessPhones')
                .get();
            return graphUser;
        } catch (err) {
            console.log(err);
        }
    },

    signOutWithAD: async function (graphUser) {
        const config = {
            auth: {
                clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
                authority: process.env.VUE_APP_AZURE_AUTHORITY,
                redirectUri: process.env.VUE_APP_AZURE_REDIRECT_URI,
            }
        };

        let client = PublicClientApplication(config);
        // you can select which account application should sign out
        const logoutRequest = {
            account: client.getAccountByHomeId(graphUser.id),
            mainWindowRedirectUri: process.env.VUE_APP_AZURE_REDIRECT_URI,
        };

        await client.logoutPopup(logoutRequest);
    }
};